/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove override" |
*
* @param {Override_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_remove = /** @type {((inputs?: Override_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer la modification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar anulación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover substituição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi sovrascrittura")
	return /** @type {LocalizedString} */ ("Remove override")
});